import { render, staticRenderFns } from "./EventTracking.vue?vue&type=template&id=229d5b3c&scoped=true&"
import script from "./EventTracking.vue?vue&type=script&lang=js&"
export * from "./EventTracking.vue?vue&type=script&lang=js&"
import style0 from "./EventTracking.vue?vue&type=style&index=0&id=229d5b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d5b3c",
  null
  
)

export default component.exports